import React from 'react';
import { Box, Button, Modal, Typography, useTheme, IconButton, Divider, MenuItem } from '@mui/material';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';

import AccountBoxIcon from '@mui/icons-material/AccountBox';
import SettingsIcon from '@mui/icons-material/Settings';
import LiveTvIcon from '@mui/icons-material/LiveTv';
import DashboardIcon from '@mui/icons-material/Dashboard';
import LogoutIcon from '@mui/icons-material/Logout';
import { useCookies } from 'react-cookie';

import { buttonStyleSx } from './AuthButtons';
import StyledMenu from '../menus/StyledMenu';

const ProfileNavButtons = ({ user={user: {}} }) => {
    const theme = useTheme();

    const menuPaths = [
        // {title: 'Profile', path: `/profile/${user['user']['username']}`, icon: <AccountBoxIcon />},
        { title: 'Dashboard', path: '/account', icon: <DashboardIcon /> },
        { title: 'Settings', path: '/account/settings', icon: <SettingsIcon /> }
    ];
    

    const [anchorElUser, setAnchorElUser] = React.useState(null);

    const [cookies, setCookie, removeCookie] = useCookies(['access', 'refresh']);

    const handleOpenUserMenu = (event) => {
        event.preventDefault();
        setAnchorElUser(event.currentTarget);
    };

    const handleCloseUserMenu = () => {
        setAnchorElUser(null);
    };

    const handleLogout = () => {
        removeCookie('access', { path: '/' });
        removeCookie('refresh', { path: '/' });
        removeCookie('access');
        removeCookie('refresh');
        console.log(cookies.access, cookies.refresh);
        window.location.replace('/');
    };

    return (
        <Box sx={{ p: 0, m: 0, display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 1 }}>
            <Button component={RouterLink} to="/account" variant="contained" sx={{ ...buttonStyleSx }}>
                <Typography variant="subtitle1">Dashboard</Typography>
            </Button>

            <IconButton onClick={handleOpenUserMenu}>
                <PersonOutlineOutlinedIcon sx={{ color: theme.palette.text.primary }} />
            </IconButton>

            <StyledMenu
                id="menu-appbar"
                anchorEl={anchorElUser}
                open={Boolean(anchorElUser)}
                onClose={handleCloseUserMenu}
            >
                {user['user'] && user['user']['username'] && (
                    <MenuItem key={11} component={RouterLink} to={`/profile/${user['user']['username']}`} onClick={handleCloseUserMenu}>
                    <AccountBoxIcon />
                    {<Typography variant="subtitle1">Profile</Typography>}
                </MenuItem>
                )}
                {menuPaths.map((menu, idx) => (
                    <MenuItem key={idx} component={RouterLink} to={menu.path} onClick={handleCloseUserMenu}>
                        {menu.icon}
                        {<Typography variant="subtitle1">{menu.title}</Typography>}
                    </MenuItem>
                ))}

                <Divider sx={{ my: 0.5 }} />

                <MenuItem key={10} onClick={handleLogout}>
                    <LogoutIcon />
                    <Typography variant="subtitle1">Logout</Typography>
                </MenuItem>
            </StyledMenu>
        </Box>
    );
};

export default ProfileNavButtons;
